import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import axios from "axios";

const BannerList = () => {
  const [loading, setLoading] = useState(true);
  const [bannerlist, setBannerList] = useState([]);

  useEffect(() => {
    setLoading(true);
    axios
      .post("https://www.aatheshsoft.com/admin_api/banner_list.php")
      .then((response) => {
        if (response.data.head.code === 200) {
          const sortedBanners = response.data.body.sort((a, b) => a.rank - b.rank );
          setBannerList(sortedBanners);
        } else {
          console.error("Error Fetching Data", response.data.head.msg);  
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleChange = (banner_id, field, value) => {
    setBannerList((prevBanners) =>
      prevBanners.map((banner) =>
        banner.banner_id === banner_id ? { ...banner, [field]: value } : banner
      )
    );
  };

  const handleUpdate = async () => {
    
    try {
      const updates = bannerlist.map(async (banner) => {
        const response = await axios.post(
          "https://www.aatheshsoft.com/admin_api/banner_list_update.php",
          {
            banner_id: banner.banner_id,
            rank: banner.rank,
            active: banner.active,
          }
        );
        console.log("banner_id", banner.banner_id);
        console.log("rank", banner.rank);
        console.log("active", banner.active);

        if (response.data.head.code !== 200) {
          console.error("Error updating banner:", response.data.head.msg);
          return false;
        }
        return true;
      });

      const results = await Promise.all(updates);
      if (results.every((res) => res === true)) {
        alert("Updated Successfully");
       window.location.reload();
         
      }
    } catch (error) {
      console.error("Error updating banners:", error);
    }
  };


  const handleDelete = async (banner_id) => {
    if (window.confirm("Are you sure you want to delete this banner?")) {
    
      try {
        const response = await axios.post("https://www.aatheshsoft.com/admin_api/banner_list_delete.php", {
          banner_id
        });
  
        if (response.data.head.code === 200) {
          alert("Banner deleted successfully");
          window.location.reload();

          
        } else {
          console.error("Error deleting banner:", response.data.head.msg);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    }
  };
  

  return (
    <>
      <Header />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper">
          <div className="page-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table">
                    <div className="card-body">
                      <div className="title-header option-title d-sm-flex d-block">
                        <h5>List of Banner Images</h5>
                        <div className="right-options">
                          <ul>
                            <li>
                              <Link className="btn btn-solid" to="/addbanner">
                                Add New Banner
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        {loading ? (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "200px" }}
                          >
                            <div
                              className="spinner-border text-primary"
                              style={{ width: "3rem", height: "3rem" }}
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="table-responsive">
                              <table
                                className="table all-package theme-table table-product"
                                id="table_id"
                              >
                                <thead>
                                  <tr>
                                    <th>S.No.</th>
                                    <th>Banners</th>
                                    <th>Rank</th>
                                    <th style={{ textAlign: "center" }}>
                                      Active
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {bannerlist.length > 0 ? (
                                    bannerlist.map((banner, index) => (
                                      <tr key={banner.banner_id}>
                                        <td>{index + 1}</td>
                                        <td>
                                          <div>
                                            <img
                                              src={banner.image}
                                              className="img-fluid"
                                              alt=""
                                              width="350px"
                                              height="300px"
                                            />
                                          </div>
                                        </td>
                                        <td style={{ width: "2px" }}>
                                          <input
                                            className="form-control"
                                            type="text"
                                            value={banner.rank}
                                            name={`rank_${banner.banner_id}`}
                                            onChange={(e) =>
                                              handleChange(
                                                banner.banner_id,
                                                "rank",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          <input
                                            className="checkbox_animated check-it"
                                            type="checkbox"
                                            value="1"
                                            name={`act_${banner.banner_id}`}
                                            checked={banner.active === "1"}
                                            onChange={(e) =>
                                              handleChange(
                                                banner.banner_id,
                                                "active",
                                                e.target.checked ? "1" : "0"
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <ul>
                                            <li>
                                              <Link
                                                to={`/editbanner/${banner.banner_id}`}
                                              >
                                                <i className="ri-pencil-line"></i>
                                              </Link>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" onClick={() => handleDelete(banner.banner_id)}>
                                                    <i className="ri-delete-bin-line"></i>
                                                </a>
                                                </li>

                                          </ul>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="5" className="text-center">
                                        No Banners Found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </>
                        )}
                        <div className="card-footer border-0 pb-0 d-flex justify-content-end">
                          <button
                            className="btn btn-primary me-3"
                            onClick={handleUpdate}
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerList;
